<template>
  <div>
    <a-layout>
      <a-layout-content>
        <a-row :gutter="[16,16]" style="margin: 0px">
          <a-col :span="24" :md="24" :xs="24">
            <a-spin :spinning="loading">
              <a-form :form="form">
                <a-card v-if="true">
                  <a-form-model :form="form">
                    <form-model-lookup :placeholder="$t('Buscar persona')"
                                       style="width: 100%"
                                       endpoint="personas"
                                       :formItemConfig="{
                                      'label-col': {},
                                      'wrapper-col': {},
                                      'has-feedback': false
                                    }"
                                       @change="searchPersonChange"
                                       :selectedObj.sync="infoBasicEmployee"
                    >
                    </form-model-lookup>
                  </a-form-model>
                </a-card>
              </a-form>
            </a-spin>
          </a-col>
          <a-col v-if="true" :md="24" :xs="24">
            <a-card>
              <a-spin :spinning="loading">
                <a-table
                  v-bind="tbConfig"
                  :data-source="employeecv"
                  :columns="columns"
                  rowKey="id_emp"
                  :row-selection="rowSelection">
            <span slot="estado" slot-scope="text">
              <div v-if="text == 'ACTIVO'">
              <a-badge status="success"/>ACTIVO
            </div>
            <div v-if="text == 'INACTIVO'">
              <a-badge color="red"/>INACTIVO
            </div>
            </span>
                  <div
                    slot="filterDropdown"
                    slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                    style="padding: 8px"
                  >
                    <a-input
                      v-ant-ref="c => (searchInput = c)"
                      :placeholder="`Search ${column.dataIndex}`"
                      :value="selectedKeys[0]"
                      style="width: 188px; margin-bottom: 8px; display: block;"
                      @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                      @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)"
                    />
                    <a-button
                      type="primary"
                      icon="search"
                      size="small"
                      style="width: 90px; margin-right: 8px"
                      @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)"
                    >
                      Search
                    </a-button>
                    <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                      Reset
                    </a-button>
                  </div>
                  <a-icon
                    slot="filterIcon"
                    slot-scope="filtered"
                    type="search"
                    :style="{ color: filtered ? '#108ee9' : undefined }"
                  />
                  <template slot="customRender" slot-scope="text, record, index, column">
                <span v-if="searchText && searchedColumn === column.dataIndex">
                  <template
                    v-for="(fragment, i) in text
                      .toString()
                      .split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))"
                  >
                    <mark
                      v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                      :key="i"
                      class="highlight"
                    >{{ fragment }}</mark
                    >
                    <template v-else>{{ fragment }}</template>
                  </template>
                </span>
                    <template v-else>
                      {{ text }}
                    </template>
                  </template>
                </a-table>
              </a-spin>
            </a-card>
          </a-col>
        </a-row>
      </a-layout-content>
    </a-layout>
  </div>
</template>
<script>
  import HttpUtil from '@/util/HttpUtil'
  import JsUtils from '@/util/JsUtils'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  export default {
    computed: {
      rowSelection () {
        return {
          type: 'radio',
          selectedRowKeys: this.selectedRowKeys,
          onChange: (selectedRowKeys, selectedRows) => {
            this.$emit('contractSelected', selectedRows[0].id_emp)
            this.empleadoseleccionado = selectedRows[0].id_emp
            this.selectedRowKeys = selectedRowKeys
            // Si el estado del contrato es activo es igual a N
            this.status = selectedRows[0].status === 'N'
            if (!JsUtils.isEmpty(this.empleadoseleccionado)) {
              this.isVisibleEmployee = true
            } else {
              this.isVisibleEmployee = false
            }
          }
        }
      }
    },
    data () {
      return {
        status: false,
        isVisibleEmployee: false,
        form: this.$form.createForm(this, {
          name: 'formEmployee'
        }),
        empleadoseleccionado: '',
        id_emp: '',
        selectedRowKeys: [],
        id_person: '',
        persona: {},
        employeecv: [],
        infoCompleteEmployee: {},
        infoBasicEmployee: {},
        loadingParent: false,
        loading: false,
        searchText: '',
        searchInput: null,
        searchedColumn: '',
        tbConfig: {
          scroll: {x: 'max-content'},
          bordered: true,
          size: 'small',
          pagination: {
            pageSize: 5,
            showSizeChanger: true,
            pageSizeOptions: ['5', '10', '20', '30', '40'],
            showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
          }
        },
        columns: [
          {
            title: 'ID empleado',
            dataIndex: 'id_emp',
            key: 'id_emp',
            width: 200,
            sorter: (a, b) => a.id_emp - b.id_emp,
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              record.id_emp
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                }, 0)
              }
            }
          },
          {
            title: 'Compañía',
            dataIndex: 'company',
            key: 'company',
            sorter: (a, b) => a.company.length - b.company.length,
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              record.address
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                })
              }
            }
          },
          {
            title: 'Fecha inicio del contrato',
            dataIndex: 'fecha_inicio',
            key: 'fecha_inicio',
            sorter: (a, b) => a.fecha_inicio - b.fecha_inicio,
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              record.fecha_inicio
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                })
              }
            }
          },
          {
            title: 'Fecha fin del contrato',
            dataIndex: 'fecha_fin',
            key: 'fecha_fin',
            sorter: (a, b) => a.fecha_fin - b.fecha_fin,
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              record.fecha_fin
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                })
              }
            }
          },
          {
            title: 'Terminación',
            dataIndex: 'termination_date',
            key: 'termination_date_desc',
            sorter: (a, b) => a.termination_date - b.termination_date,
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              record.termination_date
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                })
              }
            }
          },
          {
            title: 'EPS',
            dataIndex: 'eps',
            align: 'right',
            key: 'eps',
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              record.eps
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                })
              }
            }
          },
          {
            title: 'Contacto',
            dataIndex: 'num_contacto',
            align: 'right',
            key: 'num_contacto',
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              record.num_contacto
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                })
              }
            }
          },
          {
            title: 'Email',
            dataIndex: 'mail',
            align: 'right',
            key: 'mail',
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              record.mail
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                })
              }
            }
          },
          {
            title: 'Cargo',
            dataIndex: 'cargo',
            align: 'right',
            key: 'cargo',
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              record.cargo
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                })
              }
            }
          },
          {
            title: 'Puesto',
            dataIndex: 'puesto',
            align: 'right',
            key: 'puesto',
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              record.puesto
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                })
              }
            }
          },
          {
            title: 'Estado',
            dataIndex: 'estado',
            width: 120,
            key: 'estado',
            sorter: (a, b) => a.estado.length - b.estado.length,
            fixed: 'right',
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'estado'
            },
            onFilter: (value, record) =>
              record.estado
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                })
              }
            }
          }
        ]
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
    },
    methods: {
      searchPersonChange (action) {
        if (JsUtils.isEmpty(action)) {
          this.isVisibleDatosPersonales = false
          this.isVisibleEmployee = false
          this.employeecv = []
        } else {
          this.isVisibleDatosPersonales = true
        }
      },
      handleSearch (selectedKeys, confirm, dataIndex) {
        confirm()
        this.searchText = selectedKeys[0]
        this.searchedColumn = dataIndex
      },
      handleReset (clearFilters) {
        clearFilters()
        this.searchText = ''
      },
      seleccionarMenu (e) {
        this.menuActivo = e.key
      },
      loadProfileData () {
        this.loading = true
        this.loadingParent = true
        this.httpClient.getInstance().get('employee/consultar_empleado/' + this.infoBasicEmployee.identificacion)
          .then(response => {
            this.employeecv = response.data.employeecv
          })
          .catch(() => {
            Mensajes.error('Error', 'No fue posible consultar los datos')
          })
          .then(() => {
            this.empleadoseleccionado = null
            this.selectedRowKeys = []
            this.loading = false
            this.loadingParent = false
          })
      }
    },
    watch: {
      infoBasicEmployee () {
        if (this.infoBasicEmployee && !JsUtils.isEmpty(this.infoBasicEmployee.identificacion)) {
          this.id_person = this.infoBasicEmployee.identificacion
          this.persona = this.infoBasicEmployee.persona
          this.loadProfileData()
        }
      }
    }
  }
</script>
<style>
  .highlight {
    background-color: rgb(255, 192, 105);
    padding: 0;
  }
  /*.ant-table td { white-space: nowrap; }*/
</style>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/MatrizSeguimiento/InfoEmpleado.vue